const SustainableProduct = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="59"
            viewBox="0 0 60 59"
            fill="none"
            {...props}
        >
            <path
                d="M29.3312 39.9451C29.3312 39.9451 24.6003 39.616 25.0117 35.2759C25.4231 30.9564 33.8152 23.6338 35.0083 22.5437C36.2013 21.4535 39.2455 27.4597 38.4433 33.363C37.6411 39.2663 34.5969 42.0226 27.8708 42.2077"
                stroke="#686058"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M35.2551 27.7683C33.0954 35.6668 26.5133 43.8327 26.5133 43.8327C26.5133 43.8327 24.4975 46.7535 24.4975 48.8516C24.4975 50.9496 25.2174 54.6726 33.2188 54.6726H46.5475C46.5475 54.6726 50.106 55.1663 50.106 51.1142V35.5639C50.106 31.5118 49.6123 32.2935 55.7008 32.2935C58.1279 32.2935 56.503 30.9976 54.2609 28.5293C50.3322 24.6006 33.2393 6.43813 33.2393 6.43813C33.2393 6.43813 30.5448 4.05212 28.1176 6.60268C25.6905 9.15325 8.4536 26.349 6.14986 28.6939C3.84613 31.0593 2.79711 32.2523 6.14986 32.2523C11.9503 32.2523 11.5184 31.7381 11.5184 35.7491V51.5873C11.5184 51.5873 11.6418 54.5698 15.9407 54.5698H20.8979"
                stroke="#6C5E57"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default SustainableProduct
